import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import OnsiteAdCardListItem from './OnsiteAdCardListItem'
import ItemsLoading from '../../../../../components/Loaders/ItemsLoading'
import PageSection from '../../../../../features/components/PageSection'
import SkeletonOnsiteAdCardListItem from './OnsiteAdCardListItem/Skeleton'

import { clearGetAdServerLineItems, getAdServerLineItems } from '../../../../../modules/actions/adServer'
import { rightSelector } from '../../../../../modules/selectors/rights'
import {
  adServerLineItemsErrorSelector,
  adServerLineItemsIsLoadingSelector,
  adServerLineItemsSelector,
  adServerLineItemsWasLoadedSelector
} from '../../../../../modules/selectors/adServer'

import useStyles from './styles'

const OnsiteAdsList = () => {
  const classes = useStyles()

  const dispatch = useDispatch()

  const { id: rightId } = useSelector(rightSelector)

  const adServerLineItems = useSelector(adServerLineItemsSelector)

  const onsiteAds = useMemo(() => {
    return adServerLineItems
      .map(lineItem => {
        return lineItem.ad_items.map(adItem => {
          return {
            ...adItem,
            campaign_name: lineItem.campaign_name
          }
        })
      })
      .flat()
  }, [adServerLineItems])

  useEffect(() => {
    dispatch(getAdServerLineItems({ rightId }))
  }, [dispatch, rightId])

  useEffect(
    () => () => {
      dispatch(clearGetAdServerLineItems())
    },
    [dispatch]
  )

  return (
    <>
      <ItemsLoading
        itemsLength={onsiteAds.length}
        className={classes.cardsList}
        noDataText={'There are no onsite ads to show'}
        isLoadingSelector={adServerLineItemsIsLoadingSelector}
        wasLoadedSelector={adServerLineItemsWasLoadedSelector}
        errorSelector={adServerLineItemsErrorSelector}
        initialLoadingSkeletonsNumber={5}
        SkeletonComponent={SkeletonOnsiteAdCardListItem}
        ContentWrapper={PageSection}
      >
        {onsiteAds.map(item => (
          <OnsiteAdCardListItem onsiteAd={item} key={item.name} />
        ))}
      </ItemsLoading>
    </>
  )
}

export default OnsiteAdsList
